import React, { useEffect, useRef, useState } from 'react';
import { CheckCircle2, KeyRound, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../App';
import AuthLayout from '../components/auth/AuthLayout';

const ResetPassword = () => {
  const headingRef = useRef(null);
  const [token] = useState(() => new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token') || '');
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(token ? '' : 'This reset link is incomplete. Request a new one.');
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    headingRef.current?.focus();
    // Remove the one-time bearer secret after capturing it in memory so it is
    // not retained in browser history or sent in referrer headers.
    if (token && window.location.hash) {
      window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
    }
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    if (form.password.length < 6) return setError('Use a password with at least 6 characters.');
    if (form.password !== form.confirm) return setError('The passwords do not match.');
    setBusy(true); setError('');
    try {
      await axiosInstance.post('/auth/password-reset/confirm', { token, password: form.password });
      setComplete(true);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || 'This reset link is invalid or has expired. Request a new one.');
    } finally { setBusy(false); }
  };

  return <AuthLayout><div className="enterprise-auth-card"><div className="enterprise-auth-step">
    <p className="enterprise-auth-kicker">Secure account recovery</p>
    <h2 ref={headingRef} tabIndex="-1">{complete ? 'Password updated' : 'Choose a new password'}</h2>
    {complete ? <><div className="enterprise-auth-organisation"><CheckCircle2 size={19}/><span>Your other sessions have been signed out</span></div><p className="enterprise-auth-intro">Your reset link has been used and cannot be used again. Sign in with your new password.</p><Link className="enterprise-auth-primary enterprise-auth-link-primary" to="/auth">Sign in securely</Link></> : <form onSubmit={submit} noValidate>
      <p className="enterprise-auth-intro">Use at least 6 characters. Completing this reset signs out existing sessions for your protection.</p>
      <label htmlFor="new-password">New password</label><input id="new-password" type="password" autoComplete="new-password" required minLength={6} value={form.password} onChange={event => setForm({ ...form, password: event.target.value })}/>
      <label htmlFor="confirm-password">Confirm new password</label><input id="confirm-password" type="password" autoComplete="new-password" required minLength={6} value={form.confirm} onChange={event => setForm({ ...form, confirm: event.target.value })}/>
      {error && <p className="enterprise-auth-error" role="alert">{error}</p>}
      <button className="enterprise-auth-primary" type="submit" disabled={busy || !token}>{busy ? <><Loader2 className="animate-spin" size={17}/>Updating…</> : <><KeyRound size={17}/>Update password</>}</button>
      <Link className="enterprise-auth-back" to="/forgot-password">Request a new reset link</Link>
    </form>}
  </div></div></AuthLayout>;
};

export default ResetPassword;
